///
/// EarthBrowser
///
/// Created by Matt Giger on 10/23/2026
/// Copyright (c) 2026 Geodata Labs
///
/// v55 -> v56: Legends lose their per-layer "hidden" state. Hiding is now
/// a property of the whole tray, kept for the session only
/// (dialog.legendTrayHidden), so any persisted "hidden" entry becomes a
/// chip.
///

interface LegendsV55 {
	display?: Record<string, unknown>
	[key: string]: unknown
}

export function migrateV55toV56(state: unknown): unknown {
	const s = state as Record<string, unknown> | null | undefined
	if (!s || typeof s !== "object") return state

	const userInterface = s.userInterface as Record<string, unknown> | undefined
	const legends = userInterface?.legends as LegendsV55 | undefined
	if (!userInterface || !legends?.display) return state

	const display: Record<string, unknown> = {}
	for (const [type, value] of Object.entries(legends.display)) {
		display[type] = value === "hidden" ? "chip" : value
	}

	return {
		...s,
		userInterface: {
			...userInterface,
			legends: { ...legends, display },
		},
	}
}
